var _regeneratorRuntime = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/inherits");

var Web3 = require('web3');

var cookies = require('../lib/cookies');

var Signer = require('./Signer');

var LocalSigner =
/*#__PURE__*/
function (_Signer) {
  "use strict";

  _inherits(LocalSigner, _Signer);

  function LocalSigner() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        privateKey = _ref.privateKey,
        _ref$saveKey = _ref.saveKey,
        saveKey = _ref$saveKey === void 0 ? true : _ref$saveKey;

    _classCallCheck(this, LocalSigner);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocalSigner).call(this));
    _this.web3 = new Web3();
    _this._saveKey = saveKey;

    if (_this._isValidPK(privateKey)) {
      _this._generateAccountFromPK(privateKey);
    } else {
      _this._loadOrGenerateAccount();
    }

    return _this;
  }

  _createClass(LocalSigner, [{
    key: "getAccounts",
    value: function getAccounts() {
      return [this.account.address];
    }
  }, {
    key: "signTx",
    value: function () {
      var _signTx = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(tx) {
        var _ref2, rawTransaction;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.account.signTransaction(tx);

              case 2:
                _ref2 = _context.sent;
                rawTransaction = _ref2.rawTransaction;
                return _context.abrupt("return", rawTransaction);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function signTx(_x) {
        return _signTx.apply(this, arguments);
      }

      return signTx;
    }()
  }, {
    key: "signMsg",
    value: function signMsg(msg) {
      return this.account.sign(msg).signature;
    }
  }, {
    key: "permissions",
    value: function permissions() {
      return ['readKey', 'writeKey', 'burn'];
    }
  }, {
    key: "invoke",
    value: function invoke(action, account) {
      if (!this.hasAccount(account)) {
        throw new Error('Can not call invoke, incorrect account');
      }

      switch (action) {
        case 'readKey':
          return this.account.privateKey;

        case 'writeKey':
          for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            params[_key - 2] = arguments[_key];
          }

          var newPK = params[0];

          this._generateAccountFromPK(newPK);

          return this.account.address;

        case 'burn':
          this._generateNewAccount();

          return this.account.address;

        default:
          throw new Error("Unknown action ".concat(action));
      }
    }
  }, {
    key: "_isValidPK",
    value: function _isValidPK(pk) {
      return !!pk && parseInt(pk) > 0;
    }
  }, {
    key: "_loadOrGenerateAccount",
    value: function _loadOrGenerateAccount() {
      var pk = window.localStorage && localStorage.getItem('metaPrivateKey') || cookies.getCookie('metaPrivateKey');

      if (this._isValidPK(pk)) {
        this._generateAccountFromPK(pk);
      } else {
        this._generateNewAccount();
      }
    }
  }, {
    key: "_generateAccountFromPK",
    value: function _generateAccountFromPK(privateKey) {
      this.account = new Web3().eth.accounts.privateKeyToAccount(privateKey);

      this._saveAccount();

      this.events.emit('accountChange');
    }
  }, {
    key: "_generateNewAccount",
    value: function _generateNewAccount() {
      this.account = new Web3().eth.accounts.create();

      this._saveAccount();

      this.events.emit('accountChange');
    }
  }, {
    key: "_saveAccount",
    value: function _saveAccount() {
      if (!this._saveKey) {
        return;
      }

      var privateKey = this.account.privateKey;

      if (!privateKey || !/^0x[0-9a-fA-F]{64}$/.test(privateKey)) {
        throw new Error("Invalid Private Key \"".concat(privateKey, "\""));
      }

      if (window.localStorage) {
        localStorage.setItem('metaPrivateKey', this.account.privateKey);
      }

      cookies.setCookie('metaPrivateKey', this.account.privateKey);
    }
  }]);

  return LocalSigner;
}(Signer);

module.exports = LocalSigner;